import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Reveal from "@/components/Reveal";
import { useLang } from "@/i18n";
import { useContent } from "@/content/ContentContext";

const SignatureSection = () => {
  const { t } = useLang();
  const s = t.signature;
  const img = useContent().images.signature;

  return (
    <section
      id="signature"
      className="bg-anthracite text-ivory overflow-hidden"
      data-testid="signature-section"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-24 md:py-36">
        <div className="grid md:grid-cols-12 gap-12 md:gap-16 items-center">
          <Reveal className="md:col-span-6">
            <div className="relative frame">
              <img
                src={img.dish}
                data-edit-img="signature.dish"
                alt={s.alt}
                loading="lazy"
                className="w-full aspect-[4/5] object-cover"
              />
              <span
                className="absolute -top-px -left-px bg-sand text-anthracite px-5 py-3 text-[10px] uppercase tracking-[0.28em]"
                data-testid="signature-badge"
              >
                {s.badge}
              </span>
            </div>
          </Reveal>

          <div className="md:col-span-6 md:pl-6">
            <Reveal>
              <p className="eyebrow text-sand mb-7">{s.label}</p>
              <h2 className="font-serif text-4xl md:text-6xl leading-[0.98] tracking-tight">
                {s.title}
              </h2>
            </Reveal>
            <Reveal delay={0.12}>
              <p className="mt-9 text-base md:text-lg font-light leading-relaxed text-ivory/80">
                {s.p1}
              </p>
              <p className="mt-5 text-base md:text-lg font-light leading-relaxed text-ivory/70">
                {s.p2}
              </p>
            </Reveal>
            <Reveal delay={0.2}>
              <p
                className="mt-10 pt-8 border-t border-ivory/15 font-serif italic text-xl md:text-2xl text-sand"
                data-testid="signature-quote"
              >
                {s.quote}
              </p>
              <Link
                to="/menu"
                data-testid="signature-cta"
                className="mt-10 inline-flex items-center gap-3 border border-ivory/35 px-8 py-4 text-[11px] uppercase tracking-[0.24em] hover:bg-ivory hover:text-anthracite transition-colors duration-300"
              >
                {s.cta}
                <ArrowUpRight className="w-4 h-4" strokeWidth={1.5} />
              </Link>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SignatureSection;
